var exports = {
  "Qs": "DebugModal.module__content___enZkYi",
  "kL": "DebugModal.module__container___enZkYi",
  "sN": "DebugModal.module__tabsSection___enZkYi",
  "vR": "DebugModal.module__tabs___enZkYi",
  "P1": "DebugModal.module__scrollArea___enZkYi",
  "z": "DebugModal.module__summary___enZkYi",
  "hZ": "DebugModal.module__summaryTitle___enZkYi",
  "D_": "DebugModal.module__summaryBody___enZkYi",
  "Ip": "DebugModal.module__summaryItem___enZkYi",
  "rG": "DebugModal.module__summaryLabel___enZkYi",
  "Qb": "DebugModal.module__summaryValue___enZkYi",
  "ZP": "DebugModal.module__codeSection___enZkYi",
  "Dy": "DebugModal.module__codeSurface___enZkYi",
};

module.exports = exports;
